import type MailSearchStore from './schema/MailSearchStore';
import type { SuggestionSet } from 'owa-search-service';
import { createStore } from 'owa-satcheljs';
import getDefaultAdvancedSearchViewState from 'owa-mail-advanced-search/lib/utils/getDefaultAdvancedSearchViewState';
import getRandomInt from '../utils/getRandomInt';
import { MAX_NAMES_FOR_GHOST_TEXT } from '../bootSearchConstants';

export const GENERAL_GHOST_TEXT_BANK_COUNT = 4; //keep in sync with length of array in owa-mail-search/lib/searchConstants.ts
export const PERSONALIZED_GHOST_TEXT_BANK_COUNT = 8; //keep in sync with length of array in owa-mail-search/lib/searchConstants.ts

export const defaultMailSearchStore: MailSearchStore = {
    toDate: undefined,
    fromDate: undefined,
    includeAttachments: false,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (26,5): Type 'null' is not assignable to type 'SearchScope'.
    // @ts-expect-error
    initialSearchScope: null,
    currentlySelectedFolderId: '',
    isRecursiveSearch: false,
    isCurrentFolderScope: false,
    isSearchHistoryDirty: false,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (37,5): Type 'null' is not assignable to type 'FolderForestNode'.
    // @ts-expect-error
    previousNode: null,
    searchNumber: 0,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (26,5): Type 'null' is not assignable to type 'SearchScope'.
    // @ts-expect-error
    staticSearchScope: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (46,5): Type 'null' is not assignable to type 'SearchScope[]'.
    // @ts-expect-error
    staticSearchScopeList: null,
    shouldShowAdvancedSearch: false,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultAdvancedSearchViewState called at module scope is not allowed. This may cause unwanted side effects. */
    advancedSearchViewState: getDefaultAdvancedSearchViewState(),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultAdvancedSearchViewState called at module scope is not allowed. This may cause unwanted side effects. */
    initialAdvancedSearchViewState: getDefaultAdvancedSearchViewState(),
    legacySuggestions: new Map<string, SuggestionSet>([]),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getRandomInt called at module scope is not allowed. This may cause unwanted side effects. */
    recipientForPersonalizedGhostTextIndex: getRandomInt(MAX_NAMES_FOR_GHOST_TEXT - 1),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getRandomInt called at module scope is not allowed. This may cause unwanted side effects. */
    generalizedGhostTextBankIndex: getRandomInt(GENERAL_GHOST_TEXT_BANK_COUNT - 1),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getRandomInt called at module scope is not allowed. This may cause unwanted side effects. */
    personalizedGhostTextBankIndex: getRandomInt(PERSONALIZED_GHOST_TEXT_BANK_COUNT - 1),
    usePersonalGhostText: false,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (59,5): Type 'null' is not assignable to type 'SearchProvider'.
    // @ts-expect-error
    provider: null,
    isAlterationRecourse: false,
    selectedMailboxInfo: undefined,
    lastSearchQueryText: '',
    selectedSuggestion: undefined,
    topResults: [],
    numberOfTopResultsShown: 0,
    initialTopResultsCount: 0,
};

const initialStore = { ...defaultMailSearchStore };

export const getStore = createStore<MailSearchStore>('mailSearchStore', initialStore);
export default getStore;
